import { render, staticRenderFns } from "./FormPictureDeprecated.vue?vue&type=template&id=474c9bab&scoped=true&"
import script from "./FormPictureDeprecated.vue?vue&type=script&lang=js&"
export * from "./FormPictureDeprecated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474c9bab",
  null
  
)

export default component.exports